import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
const StyledTableCell = styled(TableCell)(({ theme, maxWidth }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.grey[300],
        maxWidth: maxWidth
        // color: '#424242',//theme.palette.common.white,
        // fontWeight: 600,
    },
    [`&.${tableCellClasses.body}`]: {
        // fontSize: 14,
        maxWidth: maxWidth
    },
}));
export default StyledTableCell;
